// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LDyq","title":"styles_title__3B-sU"};